import { Component, OnInit } from "@angular/core";
import { AppMainComponent } from "../../../app.main.component";
import { MenuItem } from "primeng/api";
import { AuthService } from "src/app/core/endpoints/auth.service";
import { ApiService } from "src/app/core/services/api.service";

@Component({
	selector: "app-menu",
	templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
	public model: any[];
	public notifications: any[];
	public user: any;
	public loading: boolean = true;
	public Admin: MenuItem[] = [
		{
			label: "CONFIGURACIÓN",
			items: [
				{
					label: "Trabajadores",
					icon: "pi pi-fw pi-user",
					routerLink: ["usersWorker"],
				},
				{
					label: "Usuarios facturación",
					icon: "pi pi-fw pi-user",
					routerLink: ["usersBilling"],
				},
				{
					label: "Clientes",
					icon: "pi pi-fw pi-users",
					routerLink: ["users"],
				},
				{
					label: "Servicios",
					icon: "pi pi-fw pi-cog",
					routerLink: ["services"],
				},
				{
					label: "Extras",
					icon: "pi pi-fw pi-cog",
					routerLink: ["extras"],
				}
			],
		},
		{
			label: "VIVIENDAS",
			items: [
				{
					label: "Listado",
					icon: "pi pi-fw pi-home",
					routerLink: ["housing"],
				}
			],
		},
		{
			label: "RESERVAS",
			items: [
				{
					label: "Calendario",
					icon: "pi pi-fw pi-calendar",
					routerLink: ["services-calendar"],
				}
			],
		},
		{
			label: "FACTURACIÓN",
			items: [
				{
					label: "Listado",
					icon: "pi pi-fw pi-book",
					routerLink: ["services-calendar-list"],
				}
			],
		},
		{
			label: "LOGS",
			items: [
				{
					label: "Acceso",
					icon: "pi pi-fw pi-sign-in",
					routerLink: ["users-logs"],
				}
			],
		},
		{
			label: "API",
			items: [
				{
					label: "Google Calendar",
					icon: "pi pi-fw pi-calendar-plus",
					routerLink: ["google-calendar"],
				}
			],
		}
	];

	public Worker: MenuItem [] = [
		{
			label: "RESERVAS",
			items: [
				{
					label: "Calendario",
					icon: "pi pi-fw pi-calendar",
					routerLink: ["services-calendar"],
				}
			],
		}
	];

	public Billing: MenuItem [] = [
		{
			label: "FACTURACIÓN",
			items: [
				{
					label: "Listado",
					icon: "pi pi-fw pi-book",
					routerLink: ["services-calendar-list"],
				}
			],
		},
	];
	
	public User: MenuItem [] = [
		{
			label: "VIVIENDAS",
			items: [
				{
					label: "Listado",
					icon: "pi pi-fw pi-home",
					routerLink: ["housing"],
				}
			],
		},
		{
			label: "RESERVAS",
			items: [
				{
					label: "Calendario",
					icon: "pi pi-fw pi-calendar",
					routerLink: ["services-calendar"],
				}
			],
		},
		{
			label: "FACTURACIÓN",
			items: [
				{
					label: "Listado",
					icon: "pi pi-fw pi-book",
					routerLink: ["services-calendar-list"],
				}
			],
		},
	];

	public data: any[];

	constructor(
		public appMain: AppMainComponent,
		private auth: AuthService,
		private apiService: ApiService
	) {}

	ngOnInit() {
		this.model = [
			{
				label: "MENÚ",
				items: [
					{
						label: "Inicio",
						icon: "pi pi-fw pi-align-center",
						routerLink: ["/app"],
					},
					{
						label: "Perfil",
						icon: "pi pi-fw pi-user",
						routerLink: ["my-data"],
					},
				],
			}
		];
		this.getUser();
	}

	onKeydown(event: KeyboardEvent) {
		const nodeElement = <HTMLDivElement>event.target;
		if (event.code === "Enter" || event.code === "Space") {
			nodeElement.click();
			event.preventDefault();
		}
	}

	public getUser() {
		this.apiService.getEntity("user").subscribe({
			next: (result) => {
				this.user = result.user;
				if (this.user.role_id === 1) {
					this.model.push(...this.Admin);
				}

				if(this.user.role_id === 2){
					this.model.push(...this.Worker);
				}

				if (this.user.role_id === 3) {
					this.model.push(...this.Billing);
				}
				
				if (this.user.role_id === 4) {
					this.model.push(...this.User);
				}
				this.loading = false;
			},
			error: (err) => {
				console.error(err);
			},
			complete: () => {},
		});
	}
}
